// extracted by mini-css-extract-plugin
export default {"assetContainer":"Post_assetContainer__ETwm9","container":"Post_container__gg7Hl"};